import { ApiStoryResponse } from '../../../api/core/models';
import { BoardSettings } from '../../../model/board-settings';
import { ExtendedDescriptionType } from '../../../model/client-model/extended-description/extended-description-type';

export function mainStoryToExtendedDescription(mainStory?: ApiStoryResponse): BoardSettings['extendedDescription'] {
  if (!mainStory) {
    return undefined;
  }

  const image = mainStory.imgUrl
    ? {
        imgURL: mainStory.imgUrl,
        ...(mainStory.imageCredits ? { imgCredits: mainStory.imageCredits } : {}),
      }
    : undefined;
  return {
    type: ExtendedDescriptionType.ImagesAndTexts,
    data: {
      ...(image ? { images: [image] } : {}),
      texts: [
        {
          body: mainStory.description ?? '',
          title: mainStory.title,
        },
      ],
    },
  };
}
